import { NotificationType } from '../../types/api';

export interface NotificationStyle {
  icon: string;
  bg: string;
  label: string;
}

/**
 * Color-coded style per notification type, with dark-mode-aware backgrounds.
 */
export const NOTIFICATION_STYLES: Record<NotificationType, NotificationStyle> = {
  observation_published: {
    icon: '📝',
    bg: 'bg-blue-100 dark:bg-blue-900/40',
    label: 'Observation published',
  },
  assessment_published: {
    icon: '📊',
    bg: 'bg-green-100 dark:bg-green-900/40',
    label: 'Assessment published',
  },
  observation_submitted: {
    icon: '📋',
    bg: 'bg-yellow-100 dark:bg-yellow-900/40',
    label: 'Observation submitted',
  },
  report_completed: {
    icon: '✅',
    bg: 'bg-emerald-100 dark:bg-emerald-900/40',
    label: 'Report completed',
  },
  guardian_accepted: {
    icon: '👤',
    bg: 'bg-purple-100 dark:bg-purple-900/40',
    label: 'Guardian accepted',
  },
  lead_submitted: {
    icon: '📩',
    bg: 'bg-orange-100 dark:bg-orange-900/40',
    label: 'Lead submitted',
  },
  system_announcement: {
    icon: '📢',
    bg: 'bg-pink-100 dark:bg-pink-900/40',
    label: 'System announcement',
  },
};

export const DEFAULT_STYLE: NotificationStyle = {
  icon: '🔔',
  bg: 'bg-gray-100 dark:bg-gray-700',
  label: 'Notification',
};

export const getNotificationStyle = (
  type: string,
  fallbackIcon?: string | null
): NotificationStyle => {
  const style = NOTIFICATION_STYLES[type as NotificationType];
  if (style) return style;
  return {
    ...DEFAULT_STYLE,
    icon: fallbackIcon || DEFAULT_STYLE.icon,
  };
};
